export default __webpack_public_path__ + "static/media/icn_nav_active.05fe7906.svg";